import { render } from "./index.vue?vue&type=template&id=01bdfe9a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=01bdfe9a&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bdfe9a"]])

export default __exports__